import { render, staticRenderFns } from "./UploadType.vue?vue&type=template&id=31fda80a&scoped=true&"
import script from "./UploadType.vue?vue&type=script&lang=js&"
export * from "./UploadType.vue?vue&type=script&lang=js&"
import style0 from "./UploadType.vue?vue&type=style&index=0&id=31fda80a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fda80a",
  null
  
)

export default component.exports